import React from 'react';
import { TotalViewsIcon } from '../icons/TotalViewsIcon';
import { Diff } from '../Diff';
import { Information } from '../Information';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { ComparePreset } from '../../model/datePicker/types';
import { t } from '../../i18n';

const TotalViews = ({ value, previousValue, comparePreset }: Props) => {
  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center">
        <Information id="views" content={<small className="mb-2 text-gray-12">{t('mediaPlayback.views')}</small>} />
        <Information id="views" showMore={true} className="ms-2" />
      </div>
      <div className="d-flex align-items-center">
        <TotalViewsIcon />
        <h1 className="ms-2 mb-0 text-gray-12">{value}</h1>
      </div>
      <div className="mt-2">
        <small className="d-flex align-items-center" style={{ marginTop: 1 }}>
          <Diff value={getDiff(value, previousValue)} />
          <div className="text-gray-12 fs-7">{getComparePresetLabel(comparePreset)} ({previousValue})</div>
        </small>
      </div>
    </div>
  );
}

interface Props {
  value: number,
  previousValue: number,
  comparePreset?: ComparePreset
}

export { TotalViews };